import styled from "styled-components"

export const PlayerWrapper = styled.div`
  width: 312px;
  min-height: 54px;
  display: flex;
  align-items: center;
  background-image: url("/player_background.png");
  background-size: cover;
  background-position: center;
`
export const PlayButton = styled.div`
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  background: ${({ theme }) => theme.palette.accent.red};
  box-shadow: 0 0 10px ${({ theme }) => theme.palette.accent.red};
  cursor: pointer;
`
export const PlayerModalWrapper = styled.div`
  width: 100%;
  min-height: 54px;
  display: flex;
  align-items: center;
`
export const PlayerModalContentWrapper = styled.div`
  width: 80%;
  min-width: 312px;
  min-height: 54px;
  display: flex;
  align-items: center;
  margin-left: 15px;
  background-image: url("/player_background.png");
  background-size: cover;
  background-position: center;
`

export const AudioPlayer = styled.div`
  display: flex;
  align-items: center;
  background-image: url("/player_background.png");
`
export const AudioDuration = styled.span`
  color: ${({ color }) => (color ? color : "#df4a32")};
  font-family: "Oswald", sans-serif;
  font-size: 15px;
  font-weight: 600;
  font-style: normal;
  letter-spacing: 0.08em;
  line-height: 2.1em;
  text-align: left;
  font-style: normal;
  letter-spacing: normal;
  line-height: normal;

  @media (max-width: 768px) {
    font-size: 14px;
    letter-spacing: 1.12px;
    line-height: 21px;
  }
`
export const AudioTitle = styled.span`
  color: ${({ color }) => (color ? color : "#dad2d2")};
  font-family: "Oswald", sans-serif;
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  letter-spacing: 0.08;
  line-height: 2em;
  text-align: left;
  font-style: normal;
  letter-spacing: normal;
  line-height: normal;
  margin-right: 15px;

  @media (max-width: 768px) {
    font-size: 14px;
    letter-spacing: 1.12px;
    line-height: 21px;
  }
`

export const SVGText = styled.text`
  fill: #dad2d2;
  font-family: "Oswald", sans-serif;
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  letter-spacing: 0.16em;
  line-height: 2;
  text-align: left;
  font-style: normal;
  letter-spacing: normal;
  line-height: normal;
`

export const CC = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #dad2d2;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #dad2d2;
  font-family: "Oswald", sans-serif;
  font-size: 13px;
  font-weight: 500;
  font-style: normal;
  letter-spacing: 0.16em;
  line-height: 1;
  text-align: left;
  text-transform: uppercase;
  cursor: pointer;
  position: absolute;
  bottom: 20px;
  left: -20px;

  &:hover {
    opacity: 0.9;
  }
`

export const Transcription = styled.div`
  width: 350px;
  height: 200px;
  position: absolute;
  left: 30px;
  bottom: 30px;
  padding: 30px;
  overflow: hidden;
  border: 1px solid #dad2d2;
  background-color: rgba(74, 54, 50, 0.3);
  /* left: -300px; */
  /* Style for "Lorem ipsu" */
  color: #dad2d2;
  font-size: 16px;
  font-weight: 700;
  font-style: normal;
  letter-spacing: 0.08em;
  line-height: 2;
  text-align: left;
`

export const Text = styled.div`
  color: white;
  font-size: 16px;
  line-height: 1.8;
`

export const MPlayer = styled.aside`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 68px;
  z-index: 103;
  padding: 10px 15px;
  background-color: #23191d;
  opacity: 0.9;
  display: flex;
  align-items: center;

  @media (min-width: 992px) {
    display: none;
  }
`

export const MParagraph = styled.p`
  color: #dad2d2;
  font-family: "Oswald", sans-serif;
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  letter-spacing: 0.09em;
  line-height: 1.2;
  text-align: left;
  text-transform: uppercase;
`
export const MSpan = styled.span`
  color: #df4a32;
  margin-left: 10px;
  display: inline-flex;
`

export const ProgressBar = styled.div`
  width: 100%;
  height: 4px;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #494547;
`

export const ProgressNotch = styled.div`
  > div {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #df4a32;
    margin-top: -3px;
  }
`

export const StyledSvg = styled.svg`
  &:hover {
    opacity: 0.9;
  }

  &:focus {
    opacity: 0.9;
  }
`
